<template>
  <div class="container mt-3">
    <b-breadcrumb v-if="!isMe" :items="crumbs" class="mb-2"></b-breadcrumb>

    <!-- 未登录提示卡片 -->
    <div v-if="isMe && !isLoggedIn" class="card p-4 text-center mb-4 border-0 shadow-sm" style="background: var(--bg-card); color: var(--text-main);">
      <div class="mb-2 text-muted" style="font-size: 40px;">👤</div>
      <h6 class="font-weight-bold mb-1">当前未登录</h6>
      <p class="text-muted small mb-3">登录后可查看和发布帖子、管理关注与粉丝</p>
      <div>
        <b-button variant="primary" size="sm" to="/login" class="px-4">立即登录 / 注册</b-button>
      </div>
    </div>

    <div class="d-flex align-items-center mb-3">
      <div class="avatar-wrap">
        <img v-if="profile.avatar_url" :src="profile.avatar_url" class="avatar" />
        <div v-else class="avatar-fallback">{{ initial(profile.user_nick || profile.user_name) }}</div>
      </div>
      <div class="ml-2">
        <div class="h6 mb-1">{{ profile.user_nick || profile.user_name || (isLoggedIn ? '(未设置昵称)' : '(未登录)') }}</div>
        <div class="text-muted small">
          <span class="mr-3 clickable" @click="goFollowings">关注 {{ profile.followings || 0 }}</span>
          <span class="clickable" @click="goFollowers">粉丝 {{ profile.followers || 0 }}</span>
        </div>
      </div>
      <div class="ml-auto d-flex align-items-center" v-if="isMe">
        <b-button v-if="canPost" size="sm" variant="primary" class="mr-2" @click="goPost">发帖</b-button>
        <b-button v-if="isLoggedIn" size="sm" variant="outline-secondary" class="mr-2" to="/me/profile">设置</b-button>
        <b-button v-if="isLoggedIn" size="sm" variant="outline-danger" @click="logout">退出</b-button>
        <b-button v-else size="sm" variant="primary" to="/login">登录</b-button>
      </div>
      <div class="ml-auto" v-if="!isMe">
        <b-button size="sm" :variant="profile.followed_by_me ? 'secondary' : 'primary'" @click="toggleFollow">{{ profile.followed_by_me ? '已关注' : '关注' }}</b-button>
      </div>
    </div>
    <div class="mb-3" v-if="profile.bio"><small class="text-muted">{{ profile.bio }}</small></div>
    <div v-for="p in posts" :key="p.id" class="mb-3 p-2 border rounded">
      <div class="d-flex align-items-center justify-content-between">
        <div>
          <router-link :to="'/community/post/'+p.id"><strong>{{ p.title || '(无标题)' }}</strong></router-link>
          <small class="text-muted ml-2">{{ p.created_time }}</small>
        </div>
        <b-button v-if="isMe" variant="link" size="sm" class="p-0" @click="confirmDel(p)"><img :src="deleteIcon" alt="delete" class="thumb-icon" /></b-button>
      </div>
      <div class="text-muted mt-1">{{ excerpt(p.content) }}</div>
    </div>
    <div v-if="postsLoading" class="py-4 text-center">
      <b-spinner small type="grow"></b-spinner>
      <span class="text-muted small ml-2">正在加载帖子</span>
    </div>
    <div v-else-if="posts.length===0" class="py-4 text-center text-muted small">暂无帖子</div>
    <div v-else ref="loadMoreTrigger" class="py-3 text-center">
      <b-spinner v-if="loadingMore && hasMore" small type="grow"></b-spinner>
      <span v-if="loadingMore && hasMore" class="text-muted small ml-2">加载中</span>
      <span v-else-if="hasMore" class="text-muted small">下拉加载更多</span>
      <span v-else class="text-muted small">没有更多内容了</span>
    </div>
    <b-modal ref="delModal" hide-footer title="确认删除">
      <div>确定要删除该帖子吗？</div>
      <div class="mt-3 d-flex justify-content-end">
        <b-button variant="secondary" size="sm" class="mr-2" @click="cancelDel">取消</b-button>
        <b-button variant="danger" size="sm" @click="deleteConfirmed">删除</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { request_zzquant } from 'network/request.js'
export default {
  data(){ return { posts:[], pageSize:8, postPage:1, postApiUrl:'', hasMore:false, loadingMore:false, postsLoading:false, loadMoreObserver:null, profile:{}, isMe:false, isLoggedIn:false, canPost:false, toDelete:null, deleteIcon: require('assets/img/delete.png'), crumbs:[], onUserLogin:null, onUserLogout:null } },
  mounted(){ 
    this.isLoggedIn = !!localStorage.getItem('token');
    this.init(); 
    this.initLoadMoreObserver(); 
    try{ 
      this.onUserLogin = (e)=>{ 
        this.isLoggedIn = !!localStorage.getItem('token');
        const info = e && e.detail ? e.detail.userInfo : null; 
        this.applyUserInfo(info); 
        if(this.isMe){ this.ensureUserInfo() } 
      }; 
      this.onUserLogout = ()=>{
        this.isLoggedIn = false;
        this.profile = {};
        this.posts = [];
      };
      window.addEventListener('user-login', this.onUserLogin);
      window.addEventListener('user-logout', this.onUserLogout);
    }catch(e){ void 0 } 
  },
  beforeDestroy(){ 
    try{ 
      if(this.onUserLogin){ window.removeEventListener('user-login', this.onUserLogin) } 
      if(this.onUserLogout){ window.removeEventListener('user-logout', this.onUserLogout) } 
    }catch(e){ void 0 } 
    if(this.loadMoreObserver){ this.loadMoreObserver.disconnect(); this.loadMoreObserver = null } 
  },
  beforeRouteUpdate(to, from, next){ this.init(); next() },
  methods:{
    init(){ 
      this.isLoggedIn = !!localStorage.getItem('token');
      const id = this.$route.params && this.$route.params.id ? parseInt(this.$route.params.id) : 0; 
      const me = this.getLocalUserInfo(); 
      const meId = me.id; 
      const meRoles = me.roles;
      if(id>0 && id!==meId){ 
        this.isMe=false; 
        this.canPost=false; 
        this.postApiUrl='/v3/user/post/user/'+id; 
        this.loadProfile(id); 
        this.loadPosts(); 
      } else { 
        this.isMe=true; 
        this.canPost = meRoles.includes('post'); 
        if(this.isLoggedIn){
          this.postApiUrl='/v3/user/post/my'; 
          this.loadMyProfile(); 
          this.loadPosts(); 
          this.ensureUserInfo();
        } else {
          this.profile = {};
          this.posts = [];
        }
      } 
    },
    initLoadMoreObserver(){ if(typeof IntersectionObserver === 'undefined'){ return } if(this.loadMoreObserver){ this.loadMoreObserver.disconnect() } this.loadMoreObserver = new IntersectionObserver((entries)=>{ for(const entry of entries){ if(entry.isIntersecting && this.hasMore && !this.loadingMore && !this.postsLoading){ this.loadMorePosts() } } }, { root: null, rootMargin: '120px 0px', threshold: 0 }); this.observeLoadMoreTrigger() },
    observeLoadMoreTrigger(){ if(!this.loadMoreObserver){ return } this.loadMoreObserver.disconnect(); const el = this.$refs.loadMoreTrigger; if(el && this.hasMore && !this.postsLoading){ this.loadMoreObserver.observe(el) } },
    resetPostState(){ this.posts=[]; this.postPage=1; this.hasMore=false; this.loadingMore=false; this.postsLoading=false },
    loadPosts(){ this.resetPostState(); this.fetchPostsPage(true) },
    fetchPostsPage(reset){ if(!this.postApiUrl){ return } if(reset){ this.postsLoading = true; this.loadingMore = false; this.postPage = 1 } else { if(this.loadingMore || this.postsLoading || !this.hasMore){ return } this.loadingMore = true } const page = this.postPage;
      request_zzquant({ url:this.postApiUrl, params:{ page, page_size: this.pageSize } }).then(res=>{ const d=res.data&&res.data.data?res.data.data:[]; const items = Array.isArray(d) ? d : (Array.isArray(d.items) ? d.items : []); const nextPosts = reset ? items : this.posts.concat(items); this.posts = nextPosts;
        if(Array.isArray(d)){ this.hasMore = false } else if(typeof d.has_more === 'boolean'){ this.hasMore = !!d.has_more } else { const total = Number(d.total)||0; const p = Number(d.page)||page; const ps = Number(d.page_size)||this.pageSize; this.hasMore = p * ps < total }
        if(this.hasMore){ this.postPage = page + 1 } }).catch(()=>{ if(reset){ this.posts=[] } this.hasMore = false }).finally(()=>{ this.postsLoading = false; this.loadingMore = false; this.$nextTick(()=>{ this.observeLoadMoreTrigger() }) }) },
    loadMorePosts(){ this.fetchPostsPage(false) },
    getLocalUserInfo(){ const meInfoRaw = localStorage.getItem('user_info'); let meId = 0; let meRoles = []; try{ if(meInfoRaw){ const m=JSON.parse(meInfoRaw); meId = m.id || 0; meRoles = this.parseRoles(m.roles) } }catch(e){ void 0 } return { id: meId, roles: meRoles } },
    parseRoles(r){ return Array.isArray(r) ? r : String(r||'').split(',').map(s=>s.trim()).filter(Boolean) },
    applyUserInfo(info){ if(!info || !this.isMe) return; const roles = this.parseRoles(info.roles); this.canPost = roles.includes('post') },
    ensureUserInfo(){ try{ const tk = localStorage.getItem('token'); if(!tk){ this.canPost=false; return } request_zzquant({ url:'/v3/user/info', method:'GET' }).then(rs=>{ const info = rs && rs.data && rs.data.data ? rs.data.data : null; if(info && info.id){ try{ localStorage.setItem('user_info', JSON.stringify(info)) }catch(e){ void 0 } this.applyUserInfo(info) } }) }catch(e){ void 0 } },
    loadMyProfile(){ request_zzquant({ url:'/v3/user/profile/me', method:'GET' }).then(res=>{ const d=res.data&&res.data.data?res.data.data:{}; this.profile=d }) },
    loadProfile(id){ request_zzquant({ url:'/v3/user/profile/'+id, method:'GET' }).then(res=>{ const d=res.data&&res.data.data?res.data.data:{}; this.profile=d; this.updateCrumbs(id) }) },
    loadMyPosts(){ this.postApiUrl = '/v3/user/post/my'; this.loadPosts() },
    loadPostsByUser(id){ this.postApiUrl = '/v3/user/post/user/'+id; this.loadPosts() },
    // roles 在本地 user_info 中为字符串如 "user,canpost" 或数组
    goPost(){ this.$router.push('/me/post') },
    confirmDel(p){ this.toDelete = p; if(this.$refs.delModal){ this.$refs.delModal.show() } },
    cancelDel(){ this.toDelete = null; if(this.$refs.delModal){ this.$refs.delModal.hide() } },
    deleteConfirmed(){ const p=this.toDelete; if(!p){ return } request_zzquant({ url:'/v3/user/post/delete', method:'POST', data:{ post_id:p.id } }).then(()=>{ this.toDelete=null; if(this.$refs.delModal){ this.$refs.delModal.hide() } if(this.isMe){ this.loadMyPosts() } else { const id = this.profile.id; this.loadPostsByUser(id) } }).catch(()=>{ this.toDelete=null; if(this.$refs.delModal){ this.$refs.delModal.hide() } }) },
    full(u){ if(!u) return ''; if(u.startsWith('http')) return u; return 'https://api.zizizaizai.com'+u },
    excerpt(html){
      const txt = String(html || '').replace(/<[^>]+>/g,' ').replace(/&nbsp;/g,' ').replace(/\s+/g,' ').trim()
      return txt.length > 120 ? (txt.slice(0,120) + '…') : txt
    },
    initial(name){ const s=String(name||'').trim(); return s? s.substr(0,1): '?' },
    toggleFollow(){ const tid = this.profile.id; request_zzquant({ url:'/v3/user/follow/toggle', method:'POST', data:{ target_user_id: tid } }).then(res=>{ const d=res.data&&res.data.data?res.data.data:{}; this.profile.followed_by_me = !!d.followed; this.profile.followers = d.followers || this.profile.followers }) },
    goFollowings(){ const uid = this.profile.id; this.$router.push('/user/followings/'+uid) },
    goFollowers(){ const uid = this.profile.id; this.$router.push({ path:'/user/followings/'+uid, query:{ type:'fans' } }) },
    updateCrumbs(){ const name = (this.profile.user_nick || this.profile.user_name || '个人主页'); this.crumbs = [ { text:'首页', to:'/home' }, { text: name, active:true } ] },
    async logout() {
      const current = this.$router.currentRoute && this.$router.currentRoute.fullPath ? this.$router.currentRoute.fullPath : '/'
      try {
        await request_zzquant({ url: '/v3/auth/logout', method: 'post' })
      } catch (e) {
        console.warn('logout api failed', e)
      } finally {
        try {
          localStorage.removeItem('token')
          localStorage.removeItem('refresh_token')
          localStorage.removeItem('user_info')
        } catch (e) { console.warn('clear local auth failed', e) }
        this.isLoggedIn = false
        this.profile = {}
        this.posts = []
        window.dispatchEvent(new CustomEvent('user-logout'))
        this.$router.push({ path: '/login', query: { redirect: current } })
      }
    }
  }
}
</script>

<style>
.avatar{ width:40px; height:40px; border-radius:50%; object-fit:cover; border:1px solid #eee; }
.avatar-fallback{ width:40px; height:40px; border-radius:50%; background:#f0f0f0; border:1px solid #ddd; display:flex; align-items:center; justify-content:center; color:#333; font-weight:600; }
.clickable{ cursor:pointer; }
.thumb-icon{ width:18px; height:18px; vertical-align:middle; }
</style>
